import { ExternalLink } from "lucide-react";
import { useOpportunityLinkList } from "@/services/backend/dynamics/hooks/use-opportunity-link";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/shared/components/ui/sidebar";
import t from "@/lang/lang";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";

/**
 * DynamicsSalesLinksSidebarGroup can be used in sidebars of process pages to
 * show links to Dynamics Sales entities, related to the process.
 *
 * @param processId
 */
export function DynamicsSalesLinksSidebarGroup({
  processId,
}: {
  processId: string;
}) {
  const canAccess = useFeatureAuth("gsm.dynamics.link");
  const { list, isLoading } = useOpportunityLinkList(processId);

  if (!canAccess) {
    return null;
  }

  return (
    <SidebarGroup>
      <SidebarGroupLabel>{t("Dynamics Sales")}</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {list &&
            list.items.map((opportunityLink) => (
              <SidebarMenuItem key={opportunityLink.opportunityId}>
                <SidebarMenuButton asChild>
                  <a
                    href={opportunityLink.link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <ExternalLink className="mr-2 size-4" />
                    <span>{t("Verkaufschance")}</span>
                  </a>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          {!isLoading && list?.items.length === 0 && (
            <SidebarMenuItem>
              <SidebarMenuButton disabled>
                <span>{t("Keine Verkaufschance")}</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          )}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
